import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/headerlogged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import HomeLogged from '../../../components/user/home'

function HomeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Gestor de TI - Administrador" />
                <HeaderLogged />
                <Container>
                   <HomeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default HomeLoggedScreen;